import styled from 'styled-components';

import Countdown from 'components/countdown';
import BlockRenderer from 'components/sanity-block-renderer';

import theme from './theme';

export const StyledCountdown = styled(Countdown)`
  font-weight: ${Styles.fontWeight.heavy};
`;

export const ModalInner = styled.div`
  background-color: ${Styles.color.background};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  padding: env(safe-area-inset-top) env(safe-area-inset-left) env(safe-area-inset-bottom)
    env(safe-area-inset-right);
`;

export const PictureHeading = styled.div`
  flex-grow: 0;
  height: auto;
`;

export const BodyContent = styled.div`
  flex-grow: 1;
  position: relative;
  color: ${theme.bodyContentColor};
  padding: 1rem;
  text-align: center;
`;

export const ShortCodeWrapper = styled.div`
  text-align: center;
  background-color: ${Styles.color.black};
  border-radius: 10px;
  box-shadow: ${Styles.boxShadow};
  color: white;
  display: inline-grid;
  font-family: ${Styles.fontFamily.base};
  font-size: 1rem;
  letter-spacing: 3px;
  padding: 0.2rem;
  line-height: 1.2;
`;

export const ShortCode = styled.div<{ qrcode: boolean }>`
  padding: 0.3rem;
  font-size: ${props => (props.qrcode ? '1rem' : '2rem')};
`;
export const CouponTitle = styled.div`
  color: ${Styles.color.black};
  margin: 0.5rem 0 0.3rem;
`;

export const Name = styled(BlockRenderer)<{ isPriceVisible?: boolean }>`
  text-align: center;
  text-transform: uppercase;
  line-height: 1.1;
  font-size: 2.25rem;
  ${Styles.desktop`
    font-size: 2rem;
  `}
  & p {
    font-family: ${Styles.fontFamily.base};
  }
`;

export const Description = styled(BlockRenderer)`
  text-align: center;
  color: ${Styles.color.black};
`;

export const Directions = styled.p`
  margin-top: 0;
  text-align: center;
`;

export const Img = styled.img`
  display: block;
  margin: 1rem auto;
`;

export const RedeemInNext = styled.p`
  font-weight: ${Styles.fontWeight.heavy};
  color: ${Styles.color.black};
  margin-bottom: 0.2rem;
`;

export const UseCodeAtCashier = styled.p`
  margin: 1rem 0 0.4rem;
  color: ${Styles.color.black};
  font-weight: ${Styles.fontWeight.heavy};
  font-size: 0.9rem;
`;

export const QRCodeContainer = styled.div`
  border-radius: 10px;
  background: white;
  padding: 2px;
  width: fit-content;
  margin: 0 auto;
`;
